import * as React from "react";
const SvgBinIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 7, viewBox: "0 0 10 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 0H0V7H10V0ZM7 2H3V3H7V2Z", fill: "#1F1F1F" }));
export default SvgBinIcon;
